import React, { FC } from 'react';
import { ReactComponent as Search } from '../../../assets/Common/Search.svg';

export const SearchIcon: FC = () => <Search />;
